import EksoDataTableContainerWrapper from "components/shared/ui/Table/EksoDataTableContainerWrapper";
import UserLog from "models/bluechip/UserLog";
import UserLogTable from "./UserLogTable";

export default EksoDataTableContainerWrapper(UserLogTable, UserLog, {
  resourceTypeName: "userLogs",
  resourceName: "user_logs",
  startSort: { column: "created_at", order: "DESC" },
});
